import type { IconData } from '@stacksjs/iconify-core'

export const steps1Solid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 17.5a6.5 6.5 0 1 0 6.186 8.5h3.627a6.503 6.503 0 0 0 12.373 0h3.627a6.5 6.5 0 1 0 0-4h-3.627a6.503 6.503 0 0 0-12.372 0h-3.627A6.5 6.5 0 0 0 8 17.5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default steps1Solid
